export default __webpack_public_path__ + "static/blob-40-61d6c6e0b409c1343936a7ca6d21f185.svg";